import { defineQuery } from 'next-sanity'

export const articleBySlugQuery = defineQuery(`
  *[_type == "article" && slug.current == $slug]{
    ...,
    image {
      ...,
      "dimensions": asset->metadata.dimensions,
      "lqip": asset->metadata.lqip,
      "palette": asset->metadata.palette,
      "hasAlpha": asset->metadata.hasAlpha
    },
    publishedAt,
    _updatedAt,
    updatedAt,
    loanArticle,
    loanArticleSource,
    "author": authors[0]->{
      title,
      role
    },
    text[] {
      ...,
      markDefs[] {
        ...,
        _type == 'definition' => {
          _key,
          _type,
          "title": definitionRef->title,
          "content": definitionRef->text
        },
        _type == 'internalLink' => {
          _key,
          _type,
          "target": {
            "slug": @.reference->slug.current,
            "_type": @.reference->_type
          }
        }
      },
      _type == 'image' => {
        ...,
        "dimensions": asset->metadata.dimensions,
        "lqip": asset->metadata.lqip,
        "palette": asset->metadata.palette,
        "hasAlpha": asset->metadata.hasAlpha
      },
      _type == 'gallery' => {
        ...,
        asset->,
        images[] {
          ...,
          "dimensions": asset->metadata.dimensions,
          "lqip": asset->metadata.lqip,
          "palette": asset->metadata.palette,
          "hasAlpha": asset->metadata.hasAlpha
        }
      }
    }
  } | order(_updatedAt desc)[0]
`)
